import { Util } from "@grandvisionhq/forms";
import { useAdyen } from "@grandvisionhq/payments";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { ApplePaySessionErrors } from "../../../../../../../../../../mappers/mappers/errors-mapping.js";
const isPostalCodeValid = (country, postalCode) => {
  if (!postalCode) return false;
  if (postalCode.charAt(postalCode.length - 1) === " ") return true;
  return country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode);
};
const useValidateShippingData = () => {
  const { getLabel, country } = useIntl();
  const { featureConfigs, allowAlternativeShippingState } = useFeatureToggles();
  const { config } = useAdyen();
  const addressValidations = config?.applepay?.addressValidation;
  return (applePayShippingContactSelectedEvent, session, paymentRequest) => {
    try {
      const { shippingContact } = applePayShippingContactSelectedEvent;
      let valid = true;
      if (shippingContact.countryCode !== country) {
        session.completeShippingContactSelection({
          newTotal: paymentRequest.total,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "country",
              getLabel(ApplePaySessionErrors.ApplePayInvalidAddress)
            )
          ]
        });
        valid = false;
      }
      if (!isPostalCodeValid(shippingContact.countryCode, shippingContact?.postalCode)) {
        session.completeShippingContactSelection({
          newTotal: paymentRequest.total,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "postalCode",
              getLabel("checkout.address.postalCode.errorMessage")
            )
          ]
        });
        valid = false;
      }
      if (allowAlternativeShippingState && featureConfigs.alternativeShippingRegex) {
        const postalCodeIsInvalid = shippingContact?.postalCode && featureConfigs.alternativeShippingRegex.test(shippingContact.postalCode);
        if (postalCodeIsInvalid) {
          session.completeShippingContactSelection({
            newTotal: paymentRequest.total,
            errors: [
              new ApplePayError(
                "shippingContactInvalid",
                "postalCode",
                getLabel("checkout.address.postalCode.unavailable.errorMessage")
              )
            ]
          });
          valid = false;
        }
      }
      if (!shippingContact.locality) {
        session.completeShippingContactSelection({
          newTotal: paymentRequest.total,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "locality",
              getLabel("checkout.address.city.errorMessage")
            )
          ]
        });
        valid = false;
      }
      if (addressValidations?.firstName && !addressValidations?.firstName(shippingContact?.givenName || "")) {
        session.completeShippingContactSelection({
          newTotal: paymentRequest.total,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "name",
              getLabel("checkout.address.firstName.errorMessage")
            )
          ]
        });
        valid = false;
      }
      if (addressValidations?.lastName && !addressValidations?.lastName(shippingContact?.familyName || "")) {
        session.completeShippingContactSelection({
          newTotal: paymentRequest.total,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "name",
              getLabel("checkout.address.lastName.errorMessage")
            )
          ]
        });
        valid = false;
      }
      if (addressValidations?.streetName && shippingContact?.addressLines) {
        const addressLinesValid = shippingContact.addressLines.every(
          (line) => addressValidations?.streetName?.(line)
        );
        if (!addressLinesValid) {
          session.completeShippingContactSelection({
            newTotal: paymentRequest.total,
            errors: [
              new ApplePayError(
                "shippingContactInvalid",
                "addressLines",
                getLabel("checkout.address.streetName.errorMessage")
              )
            ]
          });
          valid = false;
        }
      }
      return valid;
    } catch (e) {
      if (!(e instanceof Error && e.name === "InvalidAccessError")) {
        throw e;
      }
      return true;
    }
  };
};
export {
  useValidateShippingData
};
//# sourceMappingURL=use-validate-shipping-data.js.map
